import {
  ConsultationStatus,
  IConsultationStatusDetails
} from "../models/types";

const EXT_URL =
  "https://diaprofil.dk/api/fhir-extensions/questionnaire-response-validated";

const emptyResult = (responseResource): IConsultationStatusDetails => {
  return {
    id: responseResource.id,
    handled: null,
    hcpId: null,
    status: null,
    hcpInitials: null,
    dateTime: null,
    comment: null,
    btnIcon: "square-outline",
    btnColor: "primary",
    btnText: "Gennemgang mangler"
  };
};

export const extractResponseValidationExt = (
  responseResource
): IConsultationStatusDetails => {
  const empty = emptyResult(responseResource);
  if (!responseResource.hasOwnProperty("extension")) {
    return empty;
  }
  const ext = responseResource.extension.find(
    elem => elem.url === EXT_URL
  ) as fhir.Extension;
  if (ext === undefined) {
    return empty;
  }
  const hcpRefExt = ext.extension.find(elem => elem.url === "hcp") || {
    valueReference: {
      reference: null,
      display: null
    }
  };
  const dateTimeExt = ext.extension.find(elem => elem.url === "dateTime") || {
    valueDateTime: null
  };
  const statusExt = ext.extension.find(elem => elem.url === "status") || {
    valueCode: null
  };
  const commentExt = ext.extension.find(elem => elem.url === "comment") || {
    valueString: null
  };
  const handled = ext.valueBoolean;
  const status = statusExt.valueCode as ConsultationStatus;
  let btnIcon: string;
  let btnColor: string;
  let btnText: string;
  switch (status) {
    case "COMPLETED_WITH_PATIENT":
      btnIcon = "checkbox-outline";
      btnColor = "dashboard-item-green";
      btnText = "Gennemgået";
      break;
    case "PARTIALLY_COMPLETED":
      btnIcon = "checkbox-outline";
      btnColor = "dashboard-item-yellow";
      btnText = "Delvist Gennemgået";
      break;
    case "PATIENT_FAILED_TO_APPEAR":
      btnIcon = "alert";
      btnColor = "dashboard-item-red";
      btnText = "Intet fremmøde";
      break;
    default:
      if (handled) {
        btnIcon = "checkbox-outline";
        btnColor = "dashboard-item-green";
        btnText = "Gennemgået";
      } else {
        btnIcon = "square-outline";
        btnColor = "primary";
        btnText = "Gennemgået?";
      }
      break;
  }

  const result: IConsultationStatusDetails = {
    id: responseResource.id,
    handled: ext.valueBoolean,
    status: status,
    hcpId: hcpRefExt.valueReference.reference,
    hcpInitials: hcpRefExt.valueReference.display,
    dateTime: dateTimeExt.valueDateTime,
    comment: commentExt.valueString,
    btnIcon,
    btnColor,
    btnText
  };
  return result;
};



// WEBPACK FOOTER //
// ./src/app/utils/extract-validation-ext.ts